import { Box, Paper, Skeleton, useTheme } from "@mui/material";
import React from "react";

/** Skeleton placeholder for the run detail pane (header + filter tabs + question cards). */
const RunDetailSkeleton: React.FC = () => {
    const theme = useTheme();
    const skeletonBg = { backgroundColor: theme.palette.gray[300] };

    return (
        <>
            {/* Header banner */}
            <Skeleton
                variant="rounded"
                height={80}
                sx={{ ...skeletonBg, borderRadius: "8px" }}
            />

            {/* Filter tabs */}
            <Box sx={{ display: "flex", gap: 1 }}>
                {Array.from({ length: 5 }, (_, i) => (
                    <Skeleton
                        key={`tab-${i}`}
                        variant="rounded"
                        width={90}
                        height={28}
                        sx={skeletonBg}
                    />
                ))}
            </Box>

            {/* Question cards */}
            {Array.from({ length: 3 }, (_, i) => (
                <Paper
                    key={`card-${i}`}
                    elevation={0}
                    sx={{
                        padding: theme.spacing(2.5),
                        borderRadius: "8px",
                        border: `1px solid ${theme.palette.gray[200]}`,
                    }}
                >
                    <Skeleton
                        variant="text"
                        width="30%"
                        height={16}
                        sx={skeletonBg}
                    />
                    <Skeleton
                        variant="text"
                        width="75%"
                        height={24}
                        sx={{ ...skeletonBg, mb: 1 }}
                    />
                    <Skeleton
                        variant="rounded"
                        height={90}
                        sx={{ ...skeletonBg, borderRadius: "8px" }}
                    />
                </Paper>
            ))}
        </>
    );
};

export default RunDetailSkeleton;
